<div class="legal-container">
    <h1>Terms of Service</h1>
    <div class="last-updated">Last Updated: December 12, 2025</div>

    <p>Please read these Terms of Service ("Terms") carefully before using the BabyMonitor.live website and service
        operated by us.</p>

    <h2>1. Acceptance of Terms</h2>
    <p>By accessing or using the Service, you agree to be bound by these Terms. If you disagree with any part of the
        terms, then you may not access the Service.</p>

    <h2>2. Description of Service</h2>
    <p>BabyMonitor.live provides a web-based baby monitoring solution that connects two devices via WebRTC technology.
        While we strive for high reliability, the Service is provided "AS IS" and is not a substitute for adult
        supervision.</p>

    <h2>3. End-to-End Encryption & Security</h2>
    <p>The video and audio feeds are peer-to-peer and encrypted in transit. However, we may store metadata (session
        duration, connection status) and generated thumbnails for the purpose of the service functionality (e.g.,
        dashboard preview). We do not record or store your full video stream on our servers.</p>

    <h2>4. Advertising</h2>
    <p>We reserve the right to display advertisements on the Service, which may be targeted based on non-personally
        identifiable information. By using the Service, you agree to the placement of such ads.</p>

    <h2>5. Limitation of Liability</h2>
    <p>In no event shall BabyMonitor.live, nor its directors, employees, partners, agents, suppliers, or affiliates, be
        liable for any indirect, incidental, special, consequential or punitive damages, including without limitation,
        loss of profits, data, use, goodwill, or other intangible losses, resulting from (i) your access to or use of or
        inability to access or use the Service; (ii) any conduct or content of any third party on the Service.</p>
    <p><strong>CRITICAL NOTICE:</strong> This app is a monitoring aid only. It does not replace the physical presence
        and supervision of a caregiver. Never rely solely on this app for the safety of a child.</p>

    <h2>6. Changes to Terms</h2>
    <p>We reserve the right, at our sole discretion, to modify or replace these Terms at any time. By continuing to
        access or use our Service after those revisions become effective, you agree to be bound by the revised terms.
    </p>

    <h2>7. Governing Law</h2>
    <p>These Terms shall be governed and construed in accordance with the laws of the jurisdiction in which the company
        is established, without regard to its conflict of law provisions.</p>
</div>